/*
 * @Description: 
 * @Author: YH
 * @Date: 2023-03-02 16:46:04
 * @LastEditTime: 2023-03-04 09:11:49
 * @LastEditors: YH
 * @Reference: 
 */
// 菜单 侧边栏
export default [
  { path: '/index', title: 'Dashbord', icon: 'home' },
  { path: '/Customer', title: 'Customer', icon: 'address-book-o' },
  { path: '/Order', title: 'Order', icon: 'file-text' },
  {
    title: 'Report',
    icon: 'line-chart',
    children: [
      { path: '/ReportOne', title: 'ReportOne', icon: 'calendar' },
      { path: '/ReportTwo', title: 'ReportTwo', icon: 'calendar' },
      { path: '/ReportThree', title: 'ReportThree', icon: 'calendar' },
      { path: '/ReportFour', title: 'ReportFour', icon: 'calendar' },
      { path: '/ReportFive', title: 'ReportFive', icon: 'calendar' },
      { path: '/ReportSix', title: 'RerportSix', icon: 'calendar' },
      { path: '/ReportSeven', title: 'ReportSeven', icon: 'calendar' },
      { path: '/ReportEight', title: 'ReportEight', icon: 'calendar' },
      { path: '/ReportNine', title: 'ReportNine', icon: 'calendar' },
      { path: '/ReportTen', title: 'ReportTen', icon: 'calendar' },
      { path: '/ReportEleven', title: 'ReportEleven', icon: 'calendar' },
    ]
  },
  { path: '/Travel', title: 'Travel', icon: 'paper-plane' },
  { path: '/competitors', title: 'competitors', icon: 'shopping-bag' },
  { path: '/competingGoods', title: 'competingGoods', icon: 'shopping-bag' },
  {
    title: 'Commitments',
    icon: 'map',
    children:[
      { path: '/Commitments', title: 'Markets List', icon: 'calendar' },
      { path: '/tableListbyCustomer', title: 'Commitments List', icon: 'calendar' },
      { path: '/tableList', title: 'Summary by Customer', icon: 'calendar' },
      { path: '/TotalCommitments', title: 'Summary by Model ', icon: 'calendar' },

    ]
  },
  { path: '/Video', title: 'Video', icon: 'video-camera' },
  { path: '/Documents', title: 'Documents', icon: 'file-text' },
  {
    title: 'Performance',
    icon: 'trophy',
    children:[
      { path: '/Performance', title: 'Division One', icon: 'calendar' },
      // { path: '/Performance2', title: 'Division Two', icon: 'calendar' },
      // { path: '/Performance3', title: 'Division Three', icon: 'calendar' },
    ]
  },
// TODO 左侧导航栏显示
 /* { path: '/ImagesAndVideo', title: 'ImagesAndVideo', icon: 'video-camera' },
  { path: '/Models', title: 'Models', icon: 'shopping-bag' },
  {
    title: 'prices',
    icon: 'dollar',
    children:[
      {path:'/prices',title:"prices",icon:"dollar"},
      { path: '/CustomerPricelists', title: 'CustomerPricelists', icon: 'dollar' },
    ],
  },
  {
    path: "/Markets",
    title: "Markets",
    icon:"shopping-bag"
  },
  {
    path:"/portalCommitments",
    title: "portalCommitments",
    icon:"clipboard"
  }*/
]
